import { Component, Input, ViewChild, AfterViewInit, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TimeUtilsService, InterpolationService, UTCDate } from 'map-wald';
import { DateElementEvent } from './date-element.component';

const MILLISECONDS_PER_DAY=24*60*60*1000;

declare var Plotly: any;

@Component({
  selector: 'date-selection',
  template: `<div class="date-control container-fluid">
  <div *ngIf="style!=='arrows'" class="row no-gutters">
    <div class="col-12 form-group-inline">
        <div class="input-group input-group-sm">
          <div *ngIf="step" class="ds-btn input-group-addon" (click)="move(-stepSize)">
            <i class="fa fa-angle-left"></i>
          </div>
          <input class="form-control form-control-sm"
                 placeholder="yyyy-mm-dd"
                 name="dp"
                 [(ngModel)]="dateStruct"
                 (ngModelChange)="dateStructChanged()"
                 ngbDatepicker
                 #d="ngbDatepicker"
                 [maxDate]="maxDateStruct"
                 [minDate]="minDateStruct"
                 [disabled]="disabled">
          <div class="ds-btn input-group-addon" (click)="disabled||d.toggle()" >
            <i class="fa fa-calendar"></i>
          </div>
          <div *ngIf="step" class="ds-btn input-group-addon" (click)="move(stepSize)">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </div>

    <!--
      <div class="col-2" >
        <button class="btn btn-secondary btn-sm" [disabled]="atMax"
                (click)="move(1)"><i class="fa fa-chevron-right"></i></button>
      </div>
    -->
  </div>

  <div *ngIf="style==='arrows'">
    <date-element *ngIf="need.day"   [src]="dateStruct" [property]="'day'" [label]="'Day'"
                  [step]="stepSize"
                  (changed)="dateElementChanged($event)"
                  [disabled]="disabled"></date-element>
    <date-element *ngIf="need.month" [src]="dateStruct" [property]="'month'" [label]="'Month'"
                  [step]="need.day?1:stepSize"
                  (changed)="dateElementChanged($event)"
                  [disabled]="disabled"></date-element>
    <date-element *ngIf="need.year"  [src]="dateStruct" [property]="'year'" [label]="'Year'"
                  (changed)="dateElementChanged($event)"
                  [disabled]="disabled"></date-element>
  </div>
</div>
`,styles: [
  `
  .date-control.container-fluid {
    padding-left: 0px;
    padding-right: 0px;
  }

  .ds-btn {
    min-width:10px;
    padding: 5px;
  }
  `
]})
export class DateSelectionComponent implements AfterViewInit  {
  @Input() date: UTCDate;
  @Output() dateChange = new EventEmitter<Date>();
  @Input() timestep: string;
  @Input() dates: UTCDate[];
  @Input() minDate: UTCDate|string;
  @Input() maxDate: UTCDate|string;
  @Input() style: ('popup'|'arrows') = 'arrows';
  @Input() stepSize = 1;
  @Input() referenceDate:string = null;
  @Input() disabled = false;
  @Input() step = false;

  need = {
    day:true,
    month:true,
    year:true
  };

  minDateStruct:NgbDateStruct;
  maxDateStruct:NgbDateStruct;
  dateStruct:NgbDateStruct;

  atMax:boolean=false;
  atMin:boolean=false;

  constructor(private timeUtils: TimeUtilsService){

  }

  ngAfterViewInit(){

  }

  ngOnChanges(changes:any){
    if(changes.dates&&this.dates){
      this.minDateStruct = this.timeUtils.convertDate(this.dates[0]);
      this.maxDateStruct = this.timeUtils.convertDate(this.dates[this.dates.length-1]);
    }

    if(changes.minDate){
      this.minDateStruct = this.timeUtils.convertDate(this.minDate);
    }

    if(changes.maxDate){
      this.maxDateStruct = this.timeUtils.convertDate(this.maxDate);
    }

    if(changes.date){
      this.dateStruct = this.timeUtils.convertDate(this.date);
    }

    if(changes.timestep){
      this.assessDateComponents();
    }
    this.checkLimits();
  }

  dateElementChanged(event:DateElementEvent){
    this.dateStruct = constrainWithinRange(this.dateStruct,this.minDateStruct,this.maxDateStruct);
    this.date = new Date(Date.UTC(this.dateStruct.year,this.dateStruct.month-1,this.dateStruct.day));
    this.alignDateWithReference(event.moved);
    this.dateChange.emit(this.date as Date);
  }

  dateStructChanged(){
    this.dateStruct = constrainWithinRange(this.dateStruct,this.minDateStruct,this.maxDateStruct);
    this.date = new Date(Date.UTC(this.dateStruct.year,this.dateStruct.month-1,this.dateStruct.day));
    // this.date.setUTCFullYear(this.dateStruct.year)
    // this.date.setUTCMonth(this.dateStruct.month-1)
    // this.date.setUTCDate(this.dateStruct.day);
    this.alignDateWithReference();
    this.dateChange.emit(this.date as Date);
  }

  assessDateComponents(){
    this.need.day = this.need.month = this.need.year = true;
    if((this.timestep==='daily')||(this.timestep==='weekly')){
      return;
    }
    this.need.day = false;

    if(this.timestep==='annual') {
      this.need.month = false;
    }
  }

  move(n:number){
    this.date = new Date(this.date&&this.date.getTime());
    this.date.setUTCDate(this.date.getUTCDate()+n);
    this.onDateChanged();
    this.dateChange.emit(this.date as Date);
  }

  onDateChanged(){
    this.checkLimits();
  }

  checkLimits(){
    this.atMax = this.timeUtils.datesEqual(this.dateStruct,this.maxDateStruct);
    this.atMin = this.timeUtils.datesEqual(this.dateStruct,this.minDateStruct);
  }
  // TODO not enforcing limits etc...

  alignDateWithReference(direction?:number): any {
    if(this.dates?.length){
      // Identify if current date is in the list of available dates
      // If not, find the first date before (if direction is < 0) or after (if direction is > 0) the current date
      // and set the current date to that date
      // If no dates are available, do nothing
      let dateIndex = this.dates.findIndex(d=>this.timeUtils.sameDate(d,this.date));
      if(dateIndex>=0){
        return;
      }
      let neighbouringDate = this.dates.findIndex(d=>d>this.date);
      if(direction<0){
        neighbouringDate--;
      }
      if(neighbouringDate>=0){
        this.date = this.dates[neighbouringDate];
        this.dateStruct = this.timeUtils.convertDate(this.date);
      }
      return;
    }

    let ref:Date;
    if(this.referenceDate){
      let refComponents = InterpolationService.interpolate(this.referenceDate,{
        year:this.date.getUTCFullYear(),
        month:this.date.getUTCMonth()+1,
        date:this.date.getUTCDate()
      }).split('-').map(s=>+s);

      ref = new Date(Date.UTC(refComponents[0],refComponents[1]-1,refComponents[2]));
    } else {
      const struct = this.timeUtils.convertDate(this.maxDate || this.minDate);
      ref = new Date(Date.UTC(struct.year,struct.month-1,struct.day));
    }

    console.log('currentRef',ref);
    console.log('currentDate',this.date);
    if(this.need.day){
      let timeSpan = MILLISECONDS_PER_DAY * this.stepSize;

      let days = (this.date.getTime() - ref.getTime())/timeSpan;
      this.date = new Date(ref.getTime() + Math.round(days)*timeSpan);
      this.dateStruct = this.timeUtils.convertDate(this.date);
    } else if(this.need.month && this.stepSize>1){
      let months = this.date.getUTCMonth() - ref.getUTCMonth();
      const timesteps = Math.round(months/this.stepSize);
      months = timesteps * this.stepSize;
      this.date = new Date(this.date.getTime());
      this.date.setUTCMonth(ref.getUTCMonth() + months);
      this.dateStruct = this.timeUtils.convertDate(this.date);
    }
  }
}

function constrainWithinRange(dateStruct: NgbDateStruct, minDateStruct: NgbDateStruct, maxDateStruct: NgbDateStruct): NgbDateStruct {
  if(isLater(dateStruct,maxDateStruct)){
    return {...maxDateStruct};
  }
  if(isLater(minDateStruct,dateStruct)){
    return {...minDateStruct};
  }
  return dateStruct;
}

function isLater(lhs:NgbDateStruct,rhs:NgbDateStruct):boolean{
  if(lhs.year>rhs.year){
    return true;
  }
  if(lhs.year<rhs.year){
    return false;
  }

  if(lhs.month>rhs.month){
    return true;
  }
  if(lhs.month<rhs.month){
    return false;
  }

  return lhs.day>rhs.day;
}